import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@fry/lib/guards';
import { PaymentListComponent } from './components';


const routes: Routes = [
  {
    path: '',
    canActivate: [
      AuthGuard,
    ],
    data: {
      requiredPermissions: ['payments.view']
    },
    children: [
      {
        path: 'all-transactions',
        component: PaymentListComponent,
        resolve: {
        },
       },
    ]
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
  ]
})
export class PaymentsRoutingModule { }
